// Owns the app side of the custom-scheme payment return: recognizing the return URL
// (handleAppPaymentReturnUrl, called from AppUrlListener's single appUrlOpen listener) and the
// in-memory channel that hands the result to AppPaymentReturnHandler.
//
// The registry in appUrlHandlers.ts takes plain functions, so the handler cannot reach the router
// itself. The result is buffered because the return can arrive before React has mounted — the app
// may have been evicted while the user was in MobilePay, in which case appUrlOpen fires during a
// cold start. Mirrors components/epassi/epassiMobileResult.ts.

import { AppPaymentReturn, parseAppReturnUrl } from '../../utils/appReturnScheme';
import { registerAppUrlHandler } from '../../appUrlHandlers';

let pendingResult: AppPaymentReturn | null = null;
let subscriber: ((result: AppPaymentReturn) => void) | null = null;

export function deliverAppPaymentReturn(result: AppPaymentReturn): void {
  if (subscriber) {
    subscriber(result);
    return;
  }
  // Latest wins — only one payment round trip can be meaningful at a time.
  pendingResult = result;
}

export function subscribeAppPaymentReturn(
  consumer: (result: AppPaymentReturn) => void
): () => void {
  subscriber = consumer;
  if (pendingResult) {
    const result = pendingResult;
    pendingResult = null;
    consumer(result);
  }
  return () => {
    if (subscriber === consumer) subscriber = null;
  };
}

// fi.kotipizza.app://payment-return?status=OK&orderid=..&order-key=..
// Returns true when the URL was a payment return and has been consumed.
export function handleAppPaymentReturnUrl(url: string): boolean {
  const result = parseAppReturnUrl(url);
  if (!result) return false;
  deliverAppPaymentReturn(result);
  return true;
}

registerAppUrlHandler(handleAppPaymentReturnUrl);
